export default __webpack_public_path__ + "static/media/Logotip_mobile_white.95347c2e.svg";